<div class="panel">
  <div class="panel__header">
    <span class="panel__header__title" *ngIf="!isQuick">{{'Setup Undercarriage in Inventory'| translate | async}} </span>
    <span class="panel__header__title" *ngIf="isQuick && this.systemType==1">{{'Quick Chain Setup'| translate | async}}</span>
    <span class="panel__header__title" *ngIf="isQuick && this.systemType==2">{{'Quick Frame Setup'| translate | async}}</span>
  </div>


  <!-- <mat-progress-bar *ngIf="_loading" mode="indeterminate" value="50"></mat-progress-bar> -->
  <mat-horizontal-stepper (selectionChange)="stepChangedManually($event)" [selectedIndex]="_selectedIndex"
                          [linear]="true">
    <div style="margin-left: 39%;" *ngIf="loadingSpinner">
      <mat-spinner> </mat-spinner>
    </div>

    <mat-step label="{{'Select Equipment'| translate | async}}">
      <div class="row">
        <div class="col-md-3">
          <form *ngIf="!_lockModel">

            <!-- <mat-form-field class="setup-form-full-width">
    <mat-select (selectionChange)="customerChanged($event)" name="customer" [(ngModel)]="_currentSelection.customer"
                placeholder="{{Translate('Select Customer')}}">
      <mat-option *ngFor="let customer of _dropDownListsFiltered.customerList" [value]="customer">
        {{ customer.Title }}
      </mat-option>
    </mat-select>
  </mat-form-field> -->
            <!-- <mat-form-field class="setup-form-full-width">
    <input
      type="text"
      placeholder="{{ Translate('Select Customer') }}"
      (input)="changeCustomerAutoComplete($event)"
      matInput
      [value]="_currentSelection.customer?.Title || ''"
      [matAutocomplete]="autoCustomer"
      [displayWith]="displayCustomer">

    <mat-autocomplete
      #autoCustomer="matAutocomplete"
      (optionSelected)="customerChanged($event.option.value)">
      <mat-option
        *ngFor="let customer of _dropDownListsFiltered.customerList"
        [value]="customer.Title">
        {{ customer.Title }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field> -->
            <mat-form-field class="setup-form-full-width">
              <input type="text" placeholder="{{Translate('Select Customer')}}" (input)="customerChanged($event)" matInput
                     [matAutocomplete]="auto2" name="selectedTitle" [(ngModel)]="selectedTitle" [ngModelOptions]="{ standalone: true }">
              <mat-autocomplete #auto2="matAutocomplete"
                                (optionSelected)="onSelectCustomer($event.option)">
                <mat-option [value]="customer.Title" *ngFor="let customer of _dropDownListsFiltered.customerList ">
                  {{customer.Title}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>




            <mat-form-field class="setup-form-full-width">
              <mat-select (selectionChange)="jobsiteChanged($event)" name="jobsite" [(ngModel)]="_currentSelection.jobSite"
                          placeholder="{{Translate('Select Job Site')}}" [ngModelOptions]="{ standalone: true }">

                <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
                  {{ jobsite.Title }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-radio-group name="updateExisting"
                             [(ngModel)]="_updateExisting"
                             (change)="updateExistingChanged($event)">

              <mat-radio-button [value]="false" *ngIf="!isQuick">
                {{ Translate('Create new system') }}
              </mat-radio-button>

              <mat-radio-button [value]="true" *ngIf="!isQuick">
                {{ Translate('Update existing') }}
              </mat-radio-button>

            </mat-radio-group>


            <!-- Existing System -->
            <mat-form-field class="setup-form-full-width" *ngIf="_updateExisting">

              <mat-select (selectionChange)="systemChanged($event)"
                          name="ucsystem"
                          [(ngModel)]="_currentSelection.system"
                          [ngModelOptions]="{ standalone: true }"
                          placeholder="{{Translate('Select System')}}">

                <mat-option *ngFor="let ucsystem of _dropDownListsFiltered.systemList"
                            [value]="ucsystem">

                  <img *ngIf="!FamilyImage_Chain && ucsystem.SystemType == 1"
                       src="/Content/Images/chain.jpg"
                       width="50"
                       alt="Chain">

                  <img *ngIf="FamilyImage_Chain && ucsystem.SystemType == 1"
                       [src]="getImage(FamilyImage_Chain)"
                       width="50">

                  <img *ngIf="!FamilyImage_Frame && ucsystem.SystemType == 2"
                       src="/Content/Images/frame.jpg"
                       width="50"
                       alt="Frame">

                  <img *ngIf="FamilyImage_Frame && ucsystem.SystemType == 2"
                       [src]="getImage(FamilyImage_Frame)"
                       width="50">

                  {{ucsystem.Serial}}

                </mat-option>

              </mat-select>

            </mat-form-field>


            <mat-form-field class="setup-form-full-width" *ngIf="!_updateExisting">

              <input type="text"
                     placeholder="{{Translate('Select Make')}}"
                     (input)="makeChanged($event)"
                     matInput
                     [matAutocomplete]="autoMake"
                     name="_Make"
                     [(ngModel)]="_currentSelection.make"
                     [ngModelOptions]="{ standalone: true }">

              <mat-autocomplete #autoMake="matAutocomplete"
                                [displayWith]="displayMake"
                                (optionSelected)="onSelectMake($event.option.value)">

                <mat-option [value]="__make"
                            *ngFor="let __make of _dropDownListsFiltered.makeList">

                  {{__make.Title}}

                </mat-option>

              </mat-autocomplete>

            </mat-form-field>


            <!-- Model -->
            <mat-form-field class="setup-form-full-width" *ngIf="!_updateExisting">

              <input type="text"
                     placeholder="{{'Select Model' | translate | async}}"
                     (input)="changeModelAutoComplete($event)"
                     matInput
                     [matAutocomplete]="autoModel"
                     name="_Model"
                     [(ngModel)]="_currentSelection.model"
                     [ngModelOptions]="{ standalone: true }">

              <mat-autocomplete #autoModel="matAutocomplete"
                                [displayWith]="displayModel"
                                (optionSelected)="modelselect($event.option.value)">

                <mat-option [value]="model"
                            *ngFor="let model of _dropDownListsFiltered.modelList">

                  {{model.Title}}

                </mat-option>

              </mat-autocomplete>

            </mat-form-field>

          </form>
          <mat-card color="warning" *ngIf="_lockModel">
            {{Translate('By changing selection you will lose all your inputs!')}} _lockModel {{_lockModel}} <button (click)="unlockInputs()" mat-icon-button>
              {{Translate('Unlock')}}
              <mat-icon aria="unlock">lock_open</mat-icon>
            </button>
          </mat-card>
          <table *ngIf="_currentSelection.system.Id != 0" class="table table-striped">
            <thead>
              <tr>
                <th>
                  {{Translate('Make')}} _lockModel {{_lockModel}}
                </th>
                <th>
                  {{Translate('Model')}}
                </th>
                <th>
                  {{Translate('Family')}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{_currentSelection.system.Make.Title}}
                </td>
                <td>
                  {{_currentSelection.system.Model.Title}}
                </td>
                <td>
                  {{_currentSelection.system.Family.Title}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--Step 0-->
      <div class="fix-control-area">
        <a mat-raised-button routerLink="/setup-undercarriage">{{'Cancel' | translate | async}}</a> <button mat-raised-button color="warn"
                                                                                  (click)="nextStep()">
          {{Translate('Next')}}
        </button>
        <span class="step-validation-text">
          <mat-error class="step-error" *ngIf="!StepValidation(0).OperationSucceed">
            {{StepValidation(0).LastMessage}}
          </mat-error>
        </span>
      </div>
    </mat-step>
    <mat-step label="{{Translate('Components')}}">
      <!--step two code-->
      <div class="step-container">
        <mat-radio-group *ngIf="!_updateExisting && !isCreatingFromAction" name="selectedSystemType" (change)="onRadioButtonChange($event)" [(ngModel)]="_selectedSystemType">
          <mat-radio-button *ngIf="!isQuick || (isQuick && isWSREInspection && systemType==1)" [value]="1">{{Translate('Chain')}}</mat-radio-button>
          <mat-radio-button *ngIf="!isQuick ||  (isQuick && isWSREInspection && systemType==2)" [value]="2">{{Translate('Frame')}}</mat-radio-button>
          <mat-radio-button *ngIf="!isQuick ||  (isQuick && isWSREInspection && systemType==3)" [value]="3">{{Translate('Idler')}}</mat-radio-button>
        </mat-radio-group>
       <!-- *ngIf="(isQuick && isWSREInspection && systemType==2)" -->
        <mat-radio-group style="margin-left: 6%;" *ngIf="(systemType==2)" (change)="onRadioButtonChangeSide($event)" [(ngModel)]="selectedSide">
          <mat-radio-button [value]="1">{{Translate('Left')}}</mat-radio-button>
          <mat-radio-button [value]="2">{{Translate('Right')}}</mat-radio-button>
          <mat-radio-button [value]="3" *ngIf="(isQuick && isWSREInspection)">{{Translate('Both')}}</mat-radio-button>
        </mat-radio-group>
        <div class="row box">
          <div class="col-md-7 setup-on-eq-system-box" *ngIf="_selectedSystemType == 1">
            <!--Left Chain-->
            <div class="row">
              <div class="col-md-3 system-img">
                <div>
                  <img *ngIf="!FamilyImage_Chain" src="/Content/Images/chain.jpg" alt="Chain">
                  <img *ngIf="FamilyImage_Chain" [src]="getImage(FamilyImage_Chain)">
                </div>
              </div>
              <div class="col-md-9">
                <h4 class="colorGreen">
                  {{Translate('Chain')}}
                </h4>
                <form>
                  <div style="display: flex; align-content: space-between;">
                    <div style="width: 50%;">
                      <mat-form-field class="setup-form-full-width" *ngIf="!hideSerial" style="padding-right: 10px;">
                        <input matInput placeholder="{{Translate('Serial Number')}}" name="_leftChainSerial"
                               [(ngModel)]="_leftChainSetup.Serial" [ngModelOptions]="{ standalone: true }">
                      </mat-form-field>
                    </div>
                    <div style="width: 50%;" *ngIf="!isQuick">
                      <mat-form-field class="setup-form-full-width">
                        <input matInput (click)="chainPicker.open()" readonly [matDatepicker]="chainPicker" class="setup-form-full-width" placeholder="{{Translate('Date of Setup')}}"  name="_leftChainSetupInstallationDate" [(ngModel)]="_leftChainSetup.InstallationDate"  [ngModelOptions]="{ standalone: true }" />
                        <mat-datepicker-toggle matSuffix [for]="chainPicker"></mat-datepicker-toggle>
                        <mat-datepicker #chainPicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="display: flex;" *ngIf="!isQuick">
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width" style="flex: 1; padding-right: 10px;">
                        <input type="number" class="setup-form-full-width" matInput placeholder="{{Translate('Historical Hours on Chain at Setup')}}"
                               name="_leftChainSetupHoursAtInstall" [(ngModel)]="_leftChainSetup.HoursAtInstall" (change)="UpdateLife(1)" [ngModelOptions]="{ standalone: true }">
                        <span matSuffix>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                    </div>
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width" *ngIf="_showDistanceSystem">
                        <input matInput placeholder="{{Translate('Historical Distance on Chain at Setup')}}" name="_leftChainSetupHistoricalDistance" [(ngModel)]="_leftChainSetup.HistoricalDistance" (change)="UpdateDOC(1)" [ngModelOptions]="{ standalone: true }">
                        <span matSuffix>{{Translate('Km')}}</span>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="display: flex;" *ngIf="!isQuick">
                    <div style="width:50%;">
                      <!--<mat-form-field class="setup-form-full-width" *ngIf="_currentSelection.system.Family.Id==177 ||_currentSelection.system.Family.Id==203">-->
                      <mat-form-field class="setup-form-full-width" *ngIf="_currentSelection.system.Family.ShowPropelHrsPerc">
                        <input type="number" min="1" matInput
                               placeholder="{{Translate('PMU on Equipment at Setup')}}" name="_leftChainSetupPMUAtInstall" [(ngModel)]="_leftChainSetup.PMUAtInstall"
                               (change)="UpdatePMU(1)" [ngModelOptions]="{ standalone: true }"><span>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                    </div>
                    <div style="width:50%;">
                      <mat-error *ngIf="ShowError==true">
                        Invalid PMU Reading: PMU on Equipment at Setup cannot be grater than Historical Hours on Chain at Setup.
                      </mat-error>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-md-7 setup-on-eq-system-box" *ngIf="_selectedSystemType == 2">
            <!--Left Frame-->
            <div class="row">
              <div class="col-md-3 system-img">
                <div>
                  <img *ngIf="!FamilyImage_Frame" src="/Content/Images/frame.jpg" alt="Left Frame">
                  <img *ngIf="FamilyImage_Frame" [src]="getImage(FamilyImage_Frame)">
                </div>
              </div>
              <div class="col-md-9">
                <h4 class="colorGreen">
                  {{Translate('Frame')}}
                </h4>
                <form>
                  <div style="display: flex; align-content: space-between;">
                    <div style="width: 50%;">
                      <mat-form-field class="setup-form-full-width" style="padding-right: 10px;" *ngIf="!hideSerial && (selectedSide==1 || selectedSide==3)">
                        <input matInput placeholder="{{Translate('Serial Number')}}" name="_leftFrameSerial"
                               [(ngModel)]="_leftFrameSetup.Serial" [ngModelOptions]="{ standalone: true }">
                      </mat-form-field>
                    </div>
                    <div style="width: 50%;">
                      <mat-form-field class="setup-form-full-width">
                        <input matInput (click)="framePicker.open()" readonly [matDatepicker]="framePicker" placeholder="Date of Setup" name="_leftFrameInstallationDate" [(ngModel)]="_leftFrameSetup.InstallationDate"  [ngModelOptions]="{ standalone: true }"/>
                        <mat-datepicker-toggle matSuffix [for]="framePicker"></mat-datepicker-toggle>
                        <mat-datepicker #framePicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="display: flex; align-content: space-between;" *ngIf="!hideSerial && (selectedSide==2 || selectedSide==3)">
                    <div style="width: 50%;">
                      <mat-form-field class="setup-form-full-width" style="padding-right: 10px;">
                        <input matInput placeholder="{{Translate('Right Serial Number')}}" name="_rightFrameSerial"
                               [(ngModel)]="_leftFrameSetup.FrameSerialRight" [ngModelOptions]="{ standalone: true }">
                      </mat-form-field>
                    </div>
                    <div style="width: 50%;">

                    </div>
                  </div>
                  <div style="display: flex;">
                    <div style="width:50%;">
                      <mat-form-field style="flex: 1; padding-right: 10px;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('Budget Life (Hrs)')}}" name="_leftFrameBudgetLife" [(ngModel)]="_leftFrameSetup.BudgetLife" [ngModelOptions]="{ standalone: true }">
                        <span matSuffix>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                    </div>
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width" *ngIf="_showDistanceSystem">
                        <input matInput placeholder="{{Translate('Budget Distance (Km)')}}" name="_leftFrameBudgetDistance" [(ngModel)]="_leftFrameSetup.BudgetDistance" [ngModelOptions]="{ standalone: true }">
                        <span matSuffix>{{Translate('Km')}}</span>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="display: flex;">
                    <div style="width:50%;">
                      <mat-form-field style="flex: 1; padding-right: 10px;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('Historical Hours on Frame at Setup')}}" name="_leftFrameSetupHoursAtInstall" [(ngModel)]="_leftFrameSetup.HoursAtInstall" (change)="UpdateLife(2)" [ngModelOptions]="{ standalone: true }">
                        <span matSuffix>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                    </div>
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width" style="flex: 1;" *ngIf="_showDistanceSystem">
                        <input matInput placeholder="{{Translate('Historical Distance on Frame at Setup')}}" name="_leftFrameSetupHistoricalDistance" [(ngModel)]="_leftFrameSetup.HistoricalDistance" (change)="UpdateDOC(2)" [ngModelOptions]="{ standalone: true }">
                        <span matSuffix>{{Translate('Km')}}</span>
                      </mat-form-field>
                    </div>
                  </div>
                  <!--<div style="display: flex;" *ngIf="_currentSelection.system.Family.Id==177 && _currentSelection.system.Family.Id==203">-->
                  <div style="display: flex;" *ngIf="_currentSelection.system.Family.ShowPropelHrsPerc">
                    <div style="width:50%;">
                      <mat-form-field style="flex: 1;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('PMU on Equipment at Setup')}}" name="_leftFramePMUHoursAtInstall" [(ngModel)]="_leftFrameSetup.PMUAtInstall" (change)="UpdatePMU(2)" [ngModelOptions]="{ standalone: true }">
                        <span matSuffix>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                    </div>
                    <div style="width:50%;">
                      <mat-error *ngIf="ShowError==true">
                        Invalid PMU Reading: PMU on Equipment at Setup cannot be grater than Historical Hours on Frame at Setup.
                      </mat-error>
                    </div>
                  </div>
                  <!--<div style="display: flex; flex-direction: row; " *ngIf="_currentSelection.system.Family.Id!=177 && _currentSelection.system.Family.Id!=203">-->
                  <div style="display: flex; flex-direction: row; " *ngIf="_currentSelection.system.Family.ShowPropelHrsPerc">
                    <div style="display: flex; flex-direction: column; width: 50%;">
                      <label>{{Translate('Frame Configuration')}}</label>
                      <mat-radio-group name="_leftFrameSetupframeConfig" [(ngModel)]="_leftFrameSetup.frameConfig" (change)="LeftFrameConfigChange($event)" [ngModelOptions]="{ standalone: true }">
                        <mat-radio-button [value]="1">{{Translate('Straight')}}</mat-radio-button>
                        <mat-radio-button [value]="2">{{Translate('Toe Out')}}</mat-radio-button>
                      </mat-radio-group>
                    </div>
                    <div style="display: flex; flex-direction: column; width: 50%;">
                      <label>{{Translate('Cannon Type')}}</label>
                      <mat-radio-group name="_leftFrameSetupcannonType" [(ngModel)]="_leftFrameSetup.cannonType" (change)="LeftFrameCannonChange($event)" [ngModelOptions]="{ standalone: true }">
                        <mat-radio-button [value]="1">{{Translate('Cast')}}</mat-radio-button>
                        <mat-radio-button [value]="2">{{Translate('Fabricated')}}</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

        </div>

        <div>

          <div class="row" *ngIf="_selectedSystemType ==3">
            <div class="col-md-6 setup-on-eq-system-box">
              <!--Idler-->
              <div class="row">
                <div class="col-md-3 img-wrap">

                  <img *ngIf="!FamilyImage_Idler" src="/Content/Images/Idler Image WSRE.jpg" alt="Left Frame">
                  <img *ngIf="FamilyImage_Idler" [src]="getImage(FamilyImage_Idler)">
                </div>
                <div class="col-md-8">
                  <h3 class="colorGreen">
                    {{Translate('Idler')}}
                  </h3>
                  <form>
                    <mat-form-field class="setup-form-full-width" *ngIf="!hideSerial">
                      <input matInput placeholder="{{Translate('Serial Number')}}" name="_IdlerFrameSerial"
                             [(ngModel)]="_IdlerSetup.Serial" [ngModelOptions]="{ standalone: true }">
                    </mat-form-field>
                  </form>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <form>
                    <div style="display: flex;">
                      <mat-form-field style="flex: 1; padding-right: 8px;">
                        <input class="_width_95" matInput placeholder="{{Translate('Life(When created in inventory)')}}"
                               name="__IdlerSetupHoursAtInstall" [(ngModel)]="_IdlerSetup.HoursAtInstall"
                               (change)="UpdateLife(3)" [ngModelOptions]="{ standalone: true }"><span>{{Translate('Hrs')}}</span>
                      </mat-form-field>

                      <mat-form-field class="setup-form-full-width " style="flex: 1; padding-right: 8px;"
                                      *ngIf="_currentSelection.system.Family.ShowPropelHrsPerc">
                        <input class="_width_95" matInput placeholder="{{Translate('PMU(When created in inventory)')}}"
                               name="__IdlerPMUAtInstall" [(ngModel)]="_IdlerSetup.PMUAtInstall"
                               (change)="UpdatePMU(3)" [ngModelOptions]="{ standalone: true }"><span>{{Translate('Hrs')}}</span>
                      </mat-form-field>

                      <mat-form-field style="flex: 1;">
                        <input class="_width_95" matInput placeholder="{{Translate('Budget Life')}}"
                               name="__IdlerBudgetLife" [(ngModel)]="_IdlerSetup.BudgetLife" (change)="updateBudgetLife(3)" [ngModelOptions]="{ standalone: true }"><span>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                    </div>
                    <div style="display: flex;">

                      <mat-form-field class="setup-form-full-width" style="flex: 1; padding-right: 8px;">
                        <input matInput placeholder="{{Translate('DOC Historical Distance on Idler at Setup')}}"
                               name="_idlerHistoricalDistance" [(ngModel)]="_IdlerSetup.HistoricalDistance" (change)="UpdateDOC(3)" [ngModelOptions]="{ standalone: true }">
                               <span matSuffix>{{ Translate(userUOD) }}</span>
                        <!-- <span matSuffix>{{Translate('{{userUOD}}')}}</span> -->
                      </mat-form-field>
                      
                      <!-- <div style="width:50%;"> -->
                      <mat-form-field class="setup-form-full-width" style="flex: 1; ">
                        <input matInput placeholder="{{Translate('Budget Distance ')}}" name="_idlerBudgetDistance" [(ngModel)]="_IdlerSetup.BudgetDistance" (change)="updateBudgetDistance(3)" [ngModelOptions]="{ standalone: true }">
                        <span matSuffix>{{ Translate(userUOD) }}</span>
                        <!-- <span matSuffix>{{Translate('{{userUOD}}')}}</span> -->
                      </mat-form-field>

                      <!-- </div> -->
                      <!-- <div style="width:50%;"> -->
                      
                        <!-- </div> -->
                    </div>
                  </form>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field class="setup-form-full-width">
                    <input matInput (click)="idlerPicker.open()" readonly [matDatepicker]="idlerPicker"
                           placeholder="Choose a date" [(ngModel)]="_IdlerSetup.InstallationDate" />
                    <mat-datepicker-toggle matSuffix [for]="idlerPicker"></mat-datepicker-toggle>
                    <mat-datepicker #idlerPicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>

          <!--end step two component-->
          <div class="row" *ngIf="_selectedSystemType == 1">
            <!--Chain components-->
            <div class="col-md-12">
              <h4>
                {{Translate('Chain Components')}}
              </h4>
              <p>
                {{Translate('Please add the components which will go on the chain.')}}
              </p>
              <div class="button-row">
                <button (click)="addComponent(1,230)" [disabled]="checkTemplateForCompartTypeButton(1,230)"
                        mat-raised-button>
                  + {{Translate('Link')}}
                </button>
                <button (click)="addComponent(1,231)" [disabled]="checkTemplateForCompartTypeButton(1,231)"
                        mat-raised-button>
                  + {{Translate('Bushing')}}
                </button>
                <button (click)="addComponent(1,232)" [disabled]="checkTemplateForCompartTypeButton(1,232)"
                        mat-raised-button>
                  + {{Translate('Shoe')}}
                </button>
                <button (click)="addComponent(1,240)" [disabled]="checkTemplateForCompartTypeButton(1,240)"
                        mat-raised-button>
                  + {{Translate('Track Elongation')}}
                </button>
              </div>

              <div style="padding: 16px" *ngIf="UCSetupType==1">
                <mat-checkbox [(ngModel)]="bShowAllPartsIds" (change)="ShowPartsIds($event)">
                  Show Parts Ids
                </mat-checkbox>
              </div>
              <div class="row setup-table-row">
                <div class="setup-component-table-container mat-elevation-z8" style="margin-bottom: 100px;">
                  <mat-table #table [dataSource]="leftchainTableDataSource">
                    <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->
                    <ng-container matColumnDef="delete">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <button [disabled]="!checkTemplateForCompartRemoveFromList(1,element.Compart.CompartType.Id)"
                                (click)="removeElement(1,element)" mat-icon-button>
                          <mat-icon *ngIf="checkTemplateForCompartRemoveFromList(1,element.Compart.CompartType.Id)"
                                    aria-label="close">close</mat-icon>
                        </button>
                        <mat-icon class="colorRed  component-status-icon"
                                  *ngIf="!validateComponent(1,element).OperationSucceed" aria-label="warning"
                                  title="{{validateComponent(1,element).LastMessage}}">warning</mat-icon>
                        <mat-icon *ngIf="validateComponent(1,element).OperationSucceed" aria-label="success"
                                  title="{{validateComponent(1,element).LastMessage}}"
                                  class="colorGreenDark component-status-icon">check_circle</mat-icon>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Component">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Type')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        {{Translate(element.Compart.CompartType.Title)}}
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Type">
                      <mat-header-cell *matHeaderCellDef>
                        <span class="colorRed">{{Translate('Component')}}*</span>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field>
                          <mat-select (selectionChange)="CompartSelected($event, element)"
                                      [ngModel]="shouldSelectDefault(element)" disableRipple>
                            <mat-option style="min-width: max-content;"
                                        *ngFor="let cmpart of getAvailableCompartList(element.Compart.CompartType.Id)"
                                        title="{{Translate(cmpart.CompartNote)}}" [value]="cmpart.Id">
                              <span style="color: #ed5565;"> {{cmpart.CompartTitle}}</span>
                              <span>
                                {{cmpart.CompartNote?':':''}} {{Translate(cmpart.CompartNote)}}
                              </span>&nbsp;
                              <span *ngIf="cmpart.ComponentPitch != null" style="color: black">Pitch {{cmpart.ComponentPitch}} {{userUOM}}</span>
                            </mat-option>
                          </mat-select>

                        </mat-form-field>
                        <mat-chip-list>
                          <mat-chip title="{{Translate('Number of inspection points')}}"
                                    *ngIf="element.Compart.MeasurementPointsNo > 1" color="accent">
                            {{Translate('MP')}}:{{element.Compart.MeasurementPointsNo}}
                          </mat-chip>
                        </mat-chip-list>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Pos">
                      <mat-header-cell *matHeaderCellDef></mat-header-cell>
                      <mat-cell class="position-cell" *matCellDef="let element">
                        {{showPosition(element)}}
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="BushTurnedPercent" *ngIf="UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef>
                        {{Translate('Bush Turn Bud %')}}
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                          <input matInput [(ngModel)]="element.BushTurnedPercent">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="MLink">
                      <mat-header-cell *matHeaderCellDef> {{Translate('M/Link')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                          <mat-select name="Mlink" (selectionChange)="MLinkChange($event,element)" disableRipple
                                      [value]="element.MLink == undefind?0:element.MLink">
                            <mat-option [value]=0>Unknown</mat-option>
                            <mat-option [value]=1>M</mat-option>
                            <mat-option [value]=2>S</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="JobNum">
                      <mat-header-cell *matHeaderCellDef>{{Translate('Job #')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                          <input matInput [(ngModel)]="element.JobNum">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Size">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Size')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                          <mat-select name="size" (selectionChange)="soheSizeSelected($event,element)"
                                      [value]="element.ShoeSize.Id" disableRipple>
                            <mat-option *ngFor="let size of _availableShoeSizes" [value]="size.Id">
                              {{size.Title}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Grouser">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Grouser')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                          <mat-select name="grouser" (selectionChange)="grouserSelected($event,element)" disableRipple
                                      [value]="element.Grouser.Id">
                            <mat-option *ngFor="let grouser of _availableGrousers"
                                        [value]="grouser.Id">{{grouser.Title}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="CleanerHoles">
                      <mat-header-cell *matHeaderCellDef>
                        {{Translate('Cleaner Holes')}}
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">

                          <mat-select name="cleanerholes" (selectionChange)="cleanerHolesChange($event,element)"
                                      [value]="element.HasCleanerHoles == undefind?0:element.HasCleanerHoles" disableRipple>
                            <mat-option *ngFor="let hole of _availableCleanerholes"
                                        [value]="hole.Id">{{hole.Title}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Brand" *ngIf="UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Brand')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field>
                          <mat-select disableRipple (selectionChange)="brandSelected($event,element)"
                                      [value]="element.Brand.Id" name="make">
                            <mat-option *ngFor="let make of _availableComponentMakes"
                                        [value]="make.Id">{{make.Title}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="OEMPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef>
                        {{Translate('OEM Part No')}}
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field>
                          <input matInput [(ngModel)]="element.OEMPartNo">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="MFRPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef>
                        {{Translate('Manufacture Part No')}}
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field>
                          <input matInput [(ngModel)]="element.MFRPartNo">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="BudgetLife" *ngIf="UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef>
                        {{Translate('Budget Life')}}
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field>
                          <input matInput [(ngModel)]="element.BudgetLife" (focusout)="budgetLifeChanged(element)">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="HoursAtInstall" *ngIf="UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef>
                        {{Translate('Hours at install')}}
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.HoursAtInstall">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="PMUAtInstall"
                                  *ngIf="(_currentSelection.system.Family.ShowPropelHrsPerc) && UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef> {{Translate('PMU')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.PMUAtInstall">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="DistanceBudget" *ngIf="UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Distance Budget')}}  </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.DistanceBudget">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="DOC" *ngIf="UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef> {{Translate('DOC')}}  </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.DOC">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="InstallCost" *ngIf="UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Cost')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.InstallCost">
                          <span matPrefix>$&nbsp;</span>
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="AssetNum">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width" *ngIf="element.Compart.CompartType.Id == 233">
                          <input matInput [(ngModel)]="element.AssetNum">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="_displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: _displayedColumns;"></mat-row>
                  </mat-table>
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="_selectedSystemType == 2">
            <!--Frame components-->
            <div class="col-md-12">
              <h4>
                {{Translate('Frame Components')}}
              </h4>
              <p>
                {{Translate('Please add the components which will go on the frame.')}}
              </p>
              <div class="button-row">
                <button (click)="addComponent(3,233)" [disabled]="checkTemplateForCompartTypeButton(3,233)"
                        mat-raised-button>
                  + {{Translate('Idler')}}
                </button>
                <button (click)="addComponent(3,236)" [disabled]="checkTemplateForCompartTypeButton(3,236)"
                        mat-raised-button>
                  + {{Translate('Sprocket')}}
                </button>
                <button (click)="addComponent(3,237)" [disabled]="checkTemplateForCompartTypeButton(3,237)"
                        mat-raised-button>
                  + {{Translate('Guard')}}
                </button>
                <!-- <button (click)="addComponent(3,240)" [disabled]="checkTemplateForCompartTypeButton(3,240)" mat-raised-button>+ {{Translate('Track Elongation')}}</button> -->
                <button (click)="addComponent(3,234)" [disabled]="checkTemplateForCompartTypeButton(3,234)"
                        mat-raised-button>
                  + {{Translate('Carrier Roller')}}
                </button>
                <button (click)="addComponent(3,235)" [disabled]="checkTemplateForCompartTypeButton(3,235)"
                        mat-raised-button>
                  + {{Translate('Track Roller')}}
                </button>
                <button (click)="addComponent(3,446)" [disabled]="checkTemplateForCompartTypeButton(3,446)"
                        mat-raised-button>
                  + {{Translate('Rear Idler')}}
                </button>

              </div>
              <div style="padding: 16px" *ngIf="UCSetupType==1">
                <mat-checkbox [(ngModel)]="bShowAllPartsIds" (change)="ShowPartsIds($event)">
                  Show Parts Ids
                </mat-checkbox>
              </div>
              <div class="row setup-table-row">
                <div class="setup-component-table-container mat-elevation-z8" style="margin-bottom: 100px;">
                  <mat-table #table [dataSource]="leftframeTableDataSource">
                    <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->
                    <ng-container matColumnDef="delete">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <button [disabled]="!checkTemplateForCompartRemoveFromList(3,element.Compart.CompartType.Id)"
                                (click)="removeElement(3,element)" mat-icon-button>
                          <mat-icon *ngIf="checkTemplateForCompartRemoveFromList(3,element.Compart.CompartType.Id)"
                                    aria-label="close">close</mat-icon>
                        </button>
                        <mat-icon class="colorRed component-status-icon"
                                  *ngIf="!validateComponent(3,element).OperationSucceed" aria-label="warning"
                                  title="{{validateComponent(3,element).LastMessage}}">warning</mat-icon>
                        <mat-icon *ngIf="validateComponent(3,element).OperationSucceed" aria-label="success"
                                  title="{{validateComponent(3,element).LastMessage}}"
                                  class="colorGreenDark component-status-icon">check_circle</mat-icon>
                      </mat-cell>
                    </ng-container>

                    <!--<ng-container matColumnDef="listPosition">
                        <mat-header-cell *matHeaderCellDef> {{Translate('No.')}} </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.listPosition}} </mat-cell>
                    </ng-container>-->

                    <ng-container matColumnDef="Component">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Type')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        {{Translate(element.Compart.CompartType.Title)}}
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Type">
                      <mat-header-cell *matHeaderCellDef>
                        <span class="colorRed">{{Translate('Component')}}*</span>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field>


                          <mat-select (selectionChange)="CompartSelected($event, element)"
                                      [ngModel]="shouldSelectDefault(element)" disableRipple>
                            <mat-option style="min-width: max-content;"
                                        *ngFor="let cmpart of getAvailableCompartList(element.Compart.CompartType.Id)"
                                        title="{{Translate(cmpart.CompartNote)}}" [value]="cmpart.Id">
                              <!-- {{cmpart.CompartTitle}}   {{cmpart.CompartNote?':':''}} {{  Translate(cmpart.CompartNote)}} -->
                              <span style="color: #ed5565;"> {{cmpart.CompartTitle}}</span>
                              <span>
                                {{cmpart.CompartNote?':':''}} {{
                              Translate(cmpart.CompartNote)
                                }}
                              </span>&nbsp;
                              <span *ngIf="cmpart.ComponentPitch != null" style="color: black">Pitch {{cmpart.ComponentPitch}} {{userUOM}}</span>
                            </mat-option>
                          </mat-select>

                        </mat-form-field>
                        <mat-chip-list>
                          <mat-chip title="{{Translate('Number of inspection points')}}"
                                    *ngIf="element.Compart.MeasurementPointsNo > 1" color="accent">
                            {{Translate('MP')}}:{{element.Compart.MeasurementPointsNo}}
                          </mat-chip>
                        </mat-chip-list>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Pos">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Position')}} </mat-header-cell>
                      <mat-cell class="position-cell" *matCellDef="let element">
                        {{showPosition(element)}}
                      </mat-cell>
                    </ng-container>

                    <!-- <ng-container matColumnDef="BushTurnedBudgetLife">
                        <mat-header-cell *matHeaderCellDef> {{Translate('Bush Turned Life')}} </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                                <input matInput [(ngModel)]="element.BushTurnedBudgetLife">
                            </mat-form-field>
                        </mat-cell>
                    </ng-container> -->

                    <ng-container matColumnDef="BushTurnedPercent">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                          <input matInput [(ngModel)]="element.BushTurnedPercent">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="MLink">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                          <mat-select name="Mlink" (selectionChange)="MLinkChange($event,element)" disableRipple
                                      [value]="element.MLink == undefind?0:element.MLink">
                            <mat-option [value]=0> {{Translate('Unknown')}} </mat-option>
                            <mat-option [value]=1>M</mat-option>
                            <mat-option [value]=2>S</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="JobNum">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                          <input matInput [(ngModel)]="element.JobNum">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Size">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                          <mat-select name="size" (selectionChange)="soheSizeSelected($event,element)"
                                      [value]="element.ShoeSize.Id" disableRipple>
                            <mat-option *ngFor="let size of _availableShoeSizes" [value]="size.Id">
                              {{size.Title}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Grouser">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                          <mat-select name="grouser" (selectionChange)="grouserSelected($event,element)" disableRipple
                                      [value]="element.Grouser.Id">
                            <mat-option *ngFor="let grouser of _availableGrousers"
                                        [value]="grouser.Id">{{grouser.Title}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="CleanerHoles">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">

                          <mat-select name="cleanerholes" (selectionChange)="cleanerHolesChange($event,element)"
                                      [value]="element.HasCleanerHoles == undefind?0:element.HasCleanerHoles" disableRipple>
                            <mat-option *ngFor="let hole of _availableCleanerholes"
                                        [value]="hole.Id">{{hole.Title}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Brand">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Brand')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field>
                          <mat-select disableRipple (selectionChange)="brandSelected($event,element)"
                                      [value]="element.Brand.Id" name="make">
                            <mat-option *ngFor="let make of _availableComponentMakes"
                                        [value]="make.Id">{{make.Title}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="OEMPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef>
                        {{Translate('OEM Part No')}}
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field>
                          <input matInput [(ngModel)]="element.OEMPartNo">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="MFRPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef>
                        {{Translate('Manufacture Part No')}}
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field>
                          <input matInput [(ngModel)]="element.MFRPartNo">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="BudgetLife" *ngIf="UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef>
                        {{Translate('Budget Life')}}
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field>
                          <input matInput [(ngModel)]="element.BudgetLife" (focusout)="budgetLifeChanged(element)">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>


                    <ng-container matColumnDef="HoursAtInstall" *ngIf="UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef>
                        {{Translate('Hours at install')}}
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.HoursAtInstall">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="PMUAtInstall"
                                  *ngIf="_currentSelection.system.Family.ShowPropelHrsPerc && UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef> {{Translate('PMU')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.PMUAtInstall">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="DistanceBudget" *ngIf="UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Distance Budget')}}  </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.DistanceBudget">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="DOC" *ngIf="UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef> {{Translate('DOC')}}  </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.DOC">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="InstallCost" *ngIf="UCSetupType==1">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Cost')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.InstallCost">
                          <span matPrefix>$&nbsp;</span>
                          <!-- <span matSuffix>.00</span> -->
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="AssetNum">
                      <mat-header-cell *matHeaderCellDef>{{Translate('Asset #')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width" *ngIf="element.Compart.CompartType.Id == 233">
                          <input matInput [(ngModel)]="element.AssetNum">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="_displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: _displayedColumns;"></mat-row>
                  </mat-table>
                </div>
              </div>
            </div>
          </div>


          <div class="row" *ngIf="_selectedSystemType == 3">
            <!--Idler components-->
            <div class="col-md-12">
              <h4>
                {{Translate('Idler')}}
              </h4>
              <p>
                {{Translate('Please add the components which will go on the idler.')}}
              </p>
              <div class="button-row">
                <button (click)="addComponent(3,233)" [disabled]="checkTemplateForCompartTypeButton(3,233)"
                        mat-raised-button>
                  + {{Translate('Idler')}}
                </button>
              </div>
              <div style="padding: 16px">
                <mat-checkbox [(ngModel)]="bShowAllPartsIds" (change)="ShowPartsIds($event)">
                  {{'Show Parts Ids' | translate | async}}
                </mat-checkbox>
              </div>

              <div class="row setup-table-row">


                <div class="setup-component-table-container mat-elevation-z8" style="margin-bottom: 100px;">
                  <mat-table #table [dataSource]="idlerTableDataSource">

                    <ng-container matColumnDef="delete">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <button [disabled]="!checkTemplateForCompartRemoveFromList(3,element.Compart.CompartType.Id)"
                                (click)="removeElement(3,element)" mat-icon-button>
                          <mat-icon *ngIf="checkTemplateForCompartRemoveFromList(3,element.Compart.CompartType.Id)"
                                    aria-label="close">close</mat-icon>
                        </button>
                        <mat-icon class="colorRed component-status-icon"
                                  *ngIf="!validateComponent(3,element).OperationSucceed" aria-label="warning"
                                  title="{{validateComponent(3,element).LastMessage}}">warning</mat-icon>
                        <mat-icon *ngIf="validateComponent(3,element).OperationSucceed" aria-label="success"
                                  title="{{validateComponent(3,element).LastMessage}}"
                                  class="colorGreenDark component-status-icon">check_circle</mat-icon>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Type">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Type')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        {{Translate(element.Compart.CompartType.Title)}}
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Component">
                      <mat-header-cell *matHeaderCellDef>
                        <span class="colorRed">{{Translate('Component')}}*</span>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field>
                          <mat-select (selectionChange)="CompartSelected($event, element)"
                                      [ngModel]="shouldSelectDefault(element)" disableRipple>
                            <mat-option style="min-width: max-content;"
                                        *ngFor="let cmpart of getAvailableCompartList(element.Compart.CompartType.Id)"
                                        title="{{Translate(cmpart.CompartNote)}}" [value]="cmpart.Id">

                              <span style="color: #ed5565;"> {{cmpart.CompartTitle}}</span>
                              <span>
                                {{cmpart.CompartNote?':':''}} {{
                              Translate(cmpart.CompartNote)
                                }}
                              </span>&nbsp;
                              <span *ngIf="cmpart.ComponentPitch != null" style="color: black">Pitch {{cmpart.ComponentPitch}} {{userUOM}}</span>
                            </mat-option>
                          </mat-select>

                        </mat-form-field>
                        <mat-chip-list>
                          <mat-chip title="{{Translate('Number of inspection points')}}"
                                    *ngIf="element.Compart.MeasurementPointsNo > 1" color="accent">
                            {{Translate('MP')}}:{{element.Compart.MeasurementPointsNo}}
                          </mat-chip>
                        </mat-chip-list>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Brand">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Brand')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field>
                          <mat-select disableRipple (selectionChange)="brandSelected($event,element)"
                                      [value]="element.Brand.Id" name="make">
                            <mat-option *ngFor="let make of _availableComponentMakes"
                                        [value]="make.Id">{{make.Title}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>


                    <ng-container matColumnDef="BudgetLife">
                      <mat-header-cell *matHeaderCellDef>
                        {{Translate('Budget Life')}}
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field>
                          <input matInput [(ngModel)]="element.BudgetLife">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="HoursAtInstall">
                      <mat-header-cell *matHeaderCellDef>
                        {{Translate('Hours at install')}}
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.HoursAtInstall">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="DistanceBudget">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Distance Budget')}} ({{userUOD}}) </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.DistanceBudget">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="DOC">
                      <mat-header-cell *matHeaderCellDef> {{Translate('DOC')}} ({{userUOD}}) </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.DOC">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="InstallCost">
                      <mat-header-cell *matHeaderCellDef> {{Translate('Cost')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.InstallCost">
                          <span matPrefix>$&nbsp;</span>
                          <!-- <span matSuffix>.00</span> -->
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="AssetNum">
                      <mat-header-cell *matHeaderCellDef>{{Translate('Asset #')}} </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width" *ngIf="element.Compart.CompartType.Id == 233">
                          <input matInput [(ngModel)]="element.AssetNum">
                        </mat-form-field>
                      </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="_displayedColumnsIdler"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: _displayedColumnsIdler;"></mat-row>
                  </mat-table>
                </div>
              </div>
            </div>
          </div>

          <div class="fix-control-area">
            <button mat-button matStepperPrevious>{{Translate('Back')}}</button> <button mat-raised-button color="warn"
                                                                                         (click)="nextStep()" [disabled]="ShowError==true">
              {{Translate('Next')}}
            </button>
            <span class="step-validation-text">
              <mat-error class="step-error" *ngIf="!StepValidation(2).OperationSucceed">
                {{StepValidation(2).LastMessage}}
              </mat-error>
            </span>
          </div>
        </div>
      </div>
    </mat-step>
    <mat-step label="{{Translate('Review and Save')}}">
      <div>
        <!--Both-->
        <div class="row box padding-16">
          <div class="col-md-9" *ngIf="_selectedSystemType == 1">
            <!--Left Chain-->
            <div class="row">
              <div class="col-md-3 img-wrap">
                <!-- <img src="/Content/Images/chain.jpg" alt="Chain"> -->
                <img *ngIf="!FamilyImage_Chain" src="/Content/Images/chain.jpg" alt="Chain">
                <img *ngIf="FamilyImage_Chain" [src]="getImage(FamilyImage_Chain)">
              </div>
              <div class="col-md-9">
                <h3>
                  {{Translate('Chain')}}
                </h3>
                <table style="width:100% !important" class="table table-sm">
                  <thead>
                    <tr>
                      <td>
                        {{Translate('Serial Number')}}
                      </td>
                      <td>
                        {{Translate('Hours at Install')}}
                      </td>
                      <td>
                        {{Translate('Date at Install')}}
                      </td>
                      <td>
                        {{Translate('Equip. SMU/Hourmeter at install')}}
                      </td>
                      <td>
                        {{Translate('Historical Distance')}}
                      </td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody class="bold">
                    <tr>
                      <td>
                        {{_leftChainSetup.Serial}}
                      </td>
                      <td>
                        {{_leftChainSetup.HoursAtInstall}}
                      </td>
                      <td>
                        {{formatDate(_leftChainSetup.InstallationDate)}}
                      </td>
                      <td>
                        {{_leftChainSetup.SmuAtInstall}}
                      </td>
                      <td>
                        {{_leftChainSetup.HistoricalDistance}}
                      </td>
                      <td>
                        <mat-icon class="colorRed" *ngIf="!_leftChainSetup.Result.OperationSucceed" aria-label="error"
                                  title="{{_leftChainSetup.Result.LastMessage}}">error</mat-icon>
                        <mat-icon class="colorGreenDark"
                                  *ngIf="_loading == 0 && _leftChainSetup.Result.OperationSucceed && _leftChainSetup.Id != 0"
                                  aria-label="check" title="{{_leftChainSetup.Result.LastMessage}}">
                          check_circle
                        </mat-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <table style="width:100% !important" class="table table-striped table-responsive">
                  <thead>
                    <tr>
                      <td>
                        {{Translate('Type')}}
                      </td>
                      <td>
                        {{Translate('Make')}}
                      </td>
                      <td>
                        {{Translate('Budget Life')}}
                      </td>
                      <td>
                        {{Translate('Hours at install')}}
                      </td>
                      <td>
                        {{Translate('Distance Budget')}}
                      </td>
                      <td>
                        {{Translate('DOC')}}
                      </td>
                      <td>
                        {{Translate('Cost')}}
                      </td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let component of _leftChainSetup.Components">
                      <td>
                        {{Translate(component.Compart.CompartType.Title)}}: {{component.Compart.CompartTitle}}
                      </td>
                      <td>
                        {{component.Brand.Title}}
                      </td>
                      <td>
                        {{component.BudgetLife}}
                      </td>
                      <td>
                        {{component.HoursAtInstall}}
                      </td>
                      <td>
                        {{component.DistanceBudget}}
                      </td>
                      <td>
                        {{component.DOC}}
                      </td>
                      <td>
                        {{component.InstallCost}}
                      </td>
                      <td>
                        <mat-icon class="colorRed" *ngIf="!component.Result.OperationSucceed" aria-label="error"
                                  title="{{Translate(component.Result.LastMessage)}}">error</mat-icon>
                        <mat-icon class="colorGreenDark"
                                  *ngIf="_loading == 0 && component.Result.OperationSucceed && component.Id != 0"
                                  aria-label="error" title="{{Translate(component.Result.LastMessage)}}">
                          check_circle
                        </mat-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-9" *ngIf="_selectedSystemType == 2">
            <!--Left Frame-->
            <div class="row">
              <div class="col-md-3 img-wrap">
                <img *ngIf="!FamilyImage_Frame" src="/Content/Images/frame.jpg" alt="Frame">
                <img *ngIf="FamilyImage_Frame" [src]="getImage(FamilyImage_Frame)">
              </div>
              <div class="col-md-9">
                <h3>
                  {{Translate('Frame')}}
                </h3>
                <table style="width:100% !important" class="table table-sm">
                  <thead>
                    <tr>
                      <td>
                        {{Translate('Serial Number')}}
                      </td>
                      <td>
                        {{Translate('Hours at Install')}}
                      </td>
                      <td>
                        {{Translate('Date at Install')}}
                      </td>
                      <td>
                        {{Translate('Equip. SMU/Hourmeter at install')}}
                      </td>
                      <td>
                        {{Translate('Budget Life')}}
                      </td>
                      <td>
                        {{Translate('Distance Budget')}}
                      </td>
                      <td>
                        {{Translate('Historical Distance')}}
                      </td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody class="bold">
                    <tr>
                      <td>
                        {{_leftFrameSetup.Serial}}
                      </td>
                      <td>
                        {{_leftFrameSetup.HoursAtInstall}}
                      </td>
                      <td>
                        {{formatDate(_leftFrameSetup.InstallationDate)}}
                      </td>
                      <td>
                        {{_leftFrameSetup.SmuAtInstall}}
                      </td>
                      <td>
                        {{_leftFrameSetup.BudgetLife}}
                      </td>
                      <td>
                        {{_leftFrameSetup.BudgetDistance}}
                      </td>
                      <td>
                        {{_leftFrameSetup.HistoricalDistance}}
                      </td>
                      <td>
                        <mat-icon class="colorRed" *ngIf="!_leftFrameSetup.Result.OperationSucceed" aria-label="error"
                                  title="{{_leftFrameSetup.Result.LastMessage}}">error</mat-icon>
                        <mat-icon class="colorGreenDark"
                                  *ngIf="_loading == 0 && _leftFrameSetup.Result.OperationSucceed && _leftFrameSetup.Id != 0"
                                  aria-label="check" title="{{_leftFrameSetup.Result.LastMessage}}">
                          check_circle
                        </mat-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <table style="width:100% !important" class="table table-striped  table-responsive">
                  <thead>
                    <tr>
                      <td>
                        {{Translate('Type')}}
                      </td>
                      <td>
                        {{Translate('Make')}}
                      </td>
                      <td>
                        {{Translate('Budget Life')}}
                      </td>
                      <td>
                        {{Translate('Hours at install')}}
                      </td>
                      <td>
                        {{Translate('Distance Budget')}}
                      </td>
                      <td>
                        {{Translate('DOC')}}
                      </td>
                      <td>
                        {{Translate('Cost')}}
                      </td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let component of _leftFrameSetup.Components">
                      <td>
                        {{Translate(component.Compart.CompartType.Title)}}: {{component.Compart.CompartTitle}}
                      </td>
                      <td>
                        {{component.Brand.Title}}
                      </td>
                      <td>
                        {{component.BudgetLife}}
                      </td>
                      <td>
                        {{component.HoursAtInstall}}
                      </td>
                      <td>
                        {{component.DistanceBudget}}
                      </td>
                      <td>
                        {{component.DOC}}
                      </td>
                      <td>
                        {{component.InstallCost}}
                      </td>
                      <td>
                        <mat-icon class="colorRed" *ngIf="!component.Result.OperationSucceed" aria-label="error"
                                  title="{{Translate(component.Result.LastMessage)}}">error</mat-icon>
                        <mat-icon class="colorGreenDark"
                                  *ngIf="_loading == 0 && component.Result.OperationSucceed && component.Id != 0"
                                  aria-label="error" title="{{Translate(component.Result.LastMessage)}}">
                          check_circle
                        </mat-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6" *ngIf="_selectedSystemType == 3">
            <!--Idler-->
            <div class="row">
              <div class="col-md-3 img-wrap">
                <img *ngIf="!FamilyImage_Frame" src="/Content/Images/frame.jpg" alt="Frame">
                <img *ngIf="FamilyImage_Frame" [src]="getImage(FamilyImage_Frame)">
              </div>
              <div class="col-md-8">
                <h3>
                  {{Translate('Idler')}}
                </h3>
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <td>
                        {{Translate('Serial Number')}}
                      </td>
                      <td>
                        {{Translate('Hours at Install')}}
                      </td>
                      <td>
                        {{Translate('Date at Install')}}
                      </td>
                      <td>
                        {{Translate('Equip. SMU/Hourmeter at install')}}
                      </td>
                      <td>
                        {{Translate('Distance Budget')}}
                      </td>
                      <td>
                        {{Translate('Historical Distance')}}
                      </td>
                      <td>
                        {{Translate('Budget Life')}}
                      </td>
                    </tr>
                  </thead>
                  <tbody class="bold">
                    <tr>
                      <td>
                        {{_IdlerSetup.Serial}}
                      </td>
                      <td>
                        {{_IdlerSetup.HoursAtInstall}}
                      </td>
                      <td>
                        {{formatDate(_IdlerSetup.InstallationDate)}}
                      </td>
                      <td>
                        {{_IdlerSetup.SmuAtInstall}}
                      </td>
                      <td>
                        {{_IdlerSetup.BudgetDistance}}
                      </td>
                      <td>
                        {{_IdlerSetup.HistoricalDistance}}
                      </td>
                      <td>
                        {{_IdlerSetup.BudgetLife}}
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <table class="table table-striped  table-responsive">
                  <thead>
                    <tr>
                      <td>
                        {{Translate('Type')}}
                      </td>
                      <td>
                        {{Translate('Make')}}
                      </td>
                      <td>
                        {{Translate('Budget Life')}}
                      </td>
                      <td>
                        {{Translate('Hours at install')}}
                      </td>
                      <td>
                        {{Translate('Distance Budget')}}
                      </td>
                      <td>
                        {{Translate('Historical Distance')}}
                      </td>
                      <td>
                        {{Translate('Cost')}}
                      </td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let component of _IdlerSetup.Components">
                      <td>
                        {{Translate(component.Compart.CompartType.Title)}}:{{component.Compart.CompartTitle}}
                      </td>
                      <td>
                        {{component.Brand.Title}}
                      </td>
                      <td>
                        {{component.BudgetLife}}
                      </td>
                      <td>
                        {{component.HoursAtInstall}}
                      </td>
                      <td>
                        {{_IdlerSetup.BudgetDistance}}
                      </td>
                      <td>
                        {{_IdlerSetup.HistoricalDistance}}
                      </td>
                      <td>
                        {{component.InstallCost}}
                      </td>
                      <td>
                        <mat-icon class="colorRed" *ngIf="!component.Result.OperationSucceed" aria-label="error"
                                  title="{{Translate(component.Result.LastMessage)}}">error</mat-icon>
                        <mat-icon class="colorGreenDark"
                                  *ngIf="_loading == 0 && component.Result.OperationSucceed && component.Id != 0"
                                  aria-label="error" title="{{Translate(component.Result.LastMessage)}}">
                          check_circle
                        </mat-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="fix-control-area">
        <button mat-button matStepperPrevious>{{Translate('Back')}}</button>
        <button mat-raised-button color="warn" *ngIf="!submittedSucessfully" [disabled]="_loading > 0"
                (click)="nextStep()">
          {{Translate('Submit')}}
        </button>
        <button mat-raised-button color="warn" *ngIf="submittedSucessfully && !isWSREInspection"
                [disabled]="_loading > 0" (click)="setupNewUC()">
          {{Translate('Setup new undercarriage')}}
        </button>
        <button mat-raised-button color="warn" *ngIf="submittedSucessfully && isWSREInspection  && systemType==1"
                [disabled]="_loading > 0" (click)="OnClickNewWSREInsp()">
          {{Translate('Create New Work Shop Repair Estimate')}}
        </button>
        <button mat-raised-button color="warn" *ngIf="submittedSucessfully && isWSREInspection && systemType==2"
                [disabled]="_loading > 0" (click)="OnClickNewWSREInspFrame()">
          {{Translate('Create New Work Shop Repair Estimate')}}
        </button>
        <button mat-raised-button color="warn" *ngIf="submittedSucessfully && isWSREInspection && systemType==3"
                [disabled]="_loading > 0" (click)="OnClickNewWSREInspFrame()">
          {{
          Translate('Create New Work Shop
          Repair
          Estimate')
          }}
        </button>

        <button mat-raised-button color="warn" *ngIf="submittedSucessfully && isCreatingFromAction"
                [disabled]="_loading > 0" (click)="backToAction()">
          {{
          Translate('Go back to record
          action')
          }}
        </button>
        <span class="step-validation-text">
          <mat-error class="step-error" *ngIf="!StepValidation(3).OperationSucceed">
            {{StepValidation(3).LastMessage}}
          </mat-error>
        </span>
      </div>
    </mat-step>
  </mat-horizontal-stepper>

</div>
